// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__1rNdl","h2":"styles_h2__1Vqs9"};